export const CURRENT_URL = window.location.href.split('#')[0].split('?')[0];
